import { Skeleton } from '@mui/material';

import PollActionsSkeleton from './PollActions/skeleton';
import PollTitleSkeleton from './PollTitle/skeleton';
import { headerClasses, Root } from './styles';

const HeaderSkeleton = () => {
  return (
    <Root>
      <Skeleton variant="rounded" height={48} width={48} />
      <PollTitleSkeleton className={headerClasses.titleForm} />
      <PollActionsSkeleton />
    </Root>
  );
};
export default HeaderSkeleton;
